import { useState, useEffect, useRef } from "react";
import createActivityDetector from "activity-detector";
import { useLocation, useParams, useNavigate } from "react-router";
const useIdle = () => {
  const timeO = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isIdle, setIsIdle] = useState(false);
  useEffect(() => {
    if (isIdle && !timeO.current) {
      timeO.current = setTimeout(() => {
        console.log("isIdle", location.pathname);
        if (location.pathname !== "/") {
          navigate("/");
        }
      }, 120000);
    } else if (timeO.current) {
      clearTimeout(timeO.current);
      timeO.current = null;
    }
    return () => {
      if (timeO.current) {
        clearTimeout(timeO.current);
        timeO.current = null;
      }
    };
  }, [isIdle]);
  useEffect(() => {
    const activityDetector = createActivityDetector({ timeToIdle: 2000 });
    activityDetector.on("idle", () => {
      setIsIdle(true);
    });
    activityDetector.on("active", () => setIsIdle(false));
    return () => activityDetector.stop();
  }, []);

  return isIdle;
};

export default useIdle;
